module.exports = __webpack_public_path__ + "static/media/ico_tint_max_sel.8f63d005.svg";